import React, { useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useGetUsersByBookId } from '../../../../hooks/services/sBook/useOfBook';
import { ConstrainMode, DetailsListLayoutMode, MarqueeSelection, Selection, SelectionMode, ShimmeredDetailsList } from '@fluentui/react';
import { __OBJECT_STRUCTURE_GetUserProps } from '../../../../common/ObjectStructures/sBook';
import { useDispatch } from 'react-redux';
import { action_setFireBook } from '../../../../reducers/actions/Book/actions';

const SidePanelImpersonate = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();


    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
    const inputParam_BookId = props.bookId !== null && props.bookId !== undefined ? props.bookId : null;
    const inputParam_SetterObjMessageList = props.setterObjMessageList !== null && props.setterObjMessageList !== undefined ? props.setterObjMessageList : null;
    const inputParam_SetterUserPropsObject = props.setterUserPropsObject !== null && props.setterUserPropsObject !== undefined ? props.setterUserPropsObject : null;
    const inputParam_SetterUserName = props.setterUserName !== null && props.setterUserName !== undefined ? props.setterUserName : null;
    const inputParam_SetterUser = props.setterUser !== null && props.setterUser !== undefined ? props.setterUser : null;

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const [selectedUser, setSelectedUser] = useState(null);
    const [userIsSelected, setUserIsSelected] = useState(false);

    const [bookUserList, setBookUserList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []});
    useGetUsersByBookId(inputParam_BookId, bookUserList, setBookUserList, false, inputParam_IsPanelOpen, true);
    
    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };
    const onSelectUserToImpersonate = () => {
        inputParam_SetterUserName && inputParam_SetterUserName(selectedUser.username)
        inputParam_SetterUser && inputParam_SetterUser(selectedUser)
        inputParam_SetterObjMessageList && inputParam_SetterObjMessageList(null)
        inputParam_SetterUserPropsObject && inputParam_SetterUserPropsObject(__OBJECT_STRUCTURE_GetUserProps())
        dispatch(action_setFireBook(true));
        setUserIsSelected(true)
        onDismissPanel();
    };

    const onUnImpersonate = () => {
        setSelectedUser(null)
        inputParam_SetterUserName && inputParam_SetterUserName(null)
        inputParam_SetterUser && inputParam_SetterUser(null)
        inputParam_SetterObjMessageList && inputParam_SetterObjMessageList(null)
        inputParam_SetterUserPropsObject && inputParam_SetterUserPropsObject(__OBJECT_STRUCTURE_GetUserProps())
        dispatch(action_setFireBook(true));
        setUserIsSelected(false)

        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return <div>
            <PrimaryButton onClick={ onSelectUserToImpersonate } styles={ { root: { marginRight: 8 } } }>{ t('data-lang-btn-select') }</PrimaryButton>
            {
                userIsSelected &&
                <PrimaryButton onClick={ onUnImpersonate } styles={ { root: { marginRight: 8 } } }>{ t('data-lang-btn-revert') }</PrimaryButton>
            }
            <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
        </div>
    };

    const handleSelectionChanged = () => {
        const visiblySelectedItems = _selection.getSelection();
    
        visiblySelectedItems.forEach((item) => {
            setSelectedUser(item);
        });           
        
    }
    const _selection = new Selection({
        selectionMode: SelectionMode.single,
        onSelectionChanged: () => handleSelectionChanged()
    });      
    



    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-sidepanel-listusers') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    <Col>
                    {
                        bookUserList.data &&
                        <MarqueeSelection
                            selection={_selection}
                            isDraggingConstrainedToRoot={true}
                        >
                            <ShimmeredDetailsList
                                className='list-no-filters no-compact-list big-header'
                                enableShimmer={!bookUserList.data}
                                items={bookUserList.data || []}
                                columns={ [
                                    {
                                        key: "fullname",
                                        name: t('data-lang-lbl-name'),
                                        fieldName: "fullname",
                                        minWidth: 100,
                                        maxWidth: 200,
                                        isResizable: true
                                    },
                                    {  
                                        key: 'roleName',
                                        name: t('data-lang-lbl-role'),
                                        fieldName: 'roleName',
                                        //minWidth: "10%",
                                        //maxWidth: "10%",
                                        onRender:(item, row) => {
                                            return item.roleName
                                        }
                                    } 
                                ]}
                                getKey={(...args) => (args[0] ? args[0].key : args[1])}
                                setKey="single"
                                selection={_selection}
                                selectionMode={SelectionMode.single}
                                selectionPreservedOnEmptyClick={true}
                                layoutMode={DetailsListLayoutMode.fixedColumns}
                                constrainMode={ConstrainMode.unconstrained}
                                isHeaderVisible={true}
                                enterModalSelectionOnTouch={true}
                            />
                        </MarqueeSelection>
                    }

                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelImpersonate;